import React from 'react';

const countries = ['Scotland', 'England', 'Northern Ireland', 'Ireland', 'Wales', 'UK', 'United Kingdom', 'GB', 'Great Britain'];

const Address = ({ address, area, distance, limit, empty = null }) => {
    return <span>
        {addressFormatter(address, limit, empty)}
        {area && <br />}
        {area && <span className="text-muted">{area.areaName} {distance && <>, {distance.miles} miles</>}</span>}
    </span>
};

const addressFormatter = (address, limit, empty = null) => {
    if (!address) {
        return empty;
    }

    const _limit = limit || 9;

    const filtered = {
        property: [address.flatNumber, address.streetNumber].filter(v => !!v).join(' ') ?? null,
        streetName: address.streetName ?? null,
        postcode: address.postcode ?? null,
        town: address.town ?? null,
        country: address.country ?? null,
    };

    if (Object.values(filtered).every(v => !v)) {
        return empty;
    }

    return Object.values(filtered)
        .filter(v => !!v && countries.indexOf(v) === -1)
        .filter(v => v !== true)
        .filter(v => typeof v !== 'object')
        .filter((v, i) => i < _limit)
        .join(', ')
        .replace(/,/, '');
}

export default Address;

export {
    addressFormatter
}
